module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"signin":"ログイン","signup":"新規登録","contactSupport":"サポート問い合わせ"}}')
  delete Component.options._Ctor
}
